<div class="row" *ngIf="!!customer">
  <div class="col d-flex flex-direction-row justify-content-between align-items-center">
    <h2 class="mt-4 mb-4">
      {{ customer.extra.gme.displayName }} <small>{{ customer.extra.gme.displayId }}</small>
    </h2>
    <lib-action-btn [item]="customer" [config]="actionConfigStandardService"></lib-action-btn>
  </div>
  <div class="col-12" *ngIf="showAssortmentInfo && userAssortmentName">
    <p class="text-muted mb-3">{{ 'MY_ASSORTMENT' | translate: { name: userAssortmentName } }}</p>
  </div>
  <div class="col-12">
    <lib-gung-tabset
      #ngbTab="gungTabset"
      orientation="vertical"
      [collapsible]="true"
      [sidebarLabel]="(isSalesOrAdmin ? 'CUSTOMER' : 'MY_ACCOUNT') | translate"
    >
      @for (tab of customerDetailsTabs; track tab.id) {
        <lib-gung-tab [id]="tab.id" [icon]="tab.icon">
          <ng-template libGungTabTitle>
            <div class="tab-title">
              <i *ngIf="tab.icon" [class]="tab.icon"></i>
              <span>{{ tab.name | translate }}</span>
            </div>
          </ng-template>
          <ng-template libGungTabContent>
            <div class="row">
              <div class="col-12">
                <ng-container *ngComponentOutlet="tab.component; inputs: tab.componentInputParams"></ng-container>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
      }
    </lib-gung-tabset>
  </div>
</div>
